\:host
    width: 100%

.tabs
    display: flex
    flex-wrap: wrap
    gap: 10px

    &__item
        border: 1px solid blue
        border-radius: $globalButtonRounding
        padding: 8px 16px
        cursor: pointer
        user-select: none

    &__item.active
        background-color: pink

.articles
    margin-top: 20px

.article
    display: block

    & + .article
        margin-top: 20px
